import { render, staticRenderFns } from "./edit-category-modal.vue?vue&type=template&id=051c2311&scoped=true"
import script from "./edit-category-modal.vue?vue&type=script&lang=js"
export * from "./edit-category-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c2311",
  null
  
)

export default component.exports